import { Tag } from '@applyboard/crystal-ui'

type DeliveryMethodProps = {
  deliveryMethod: string
}

export function DeliveryMethod(props: DeliveryMethodProps) {
  return <Tag intent="secondary">{props.deliveryMethod === 'online' ? 'Online' : 'In-Person'}</Tag>
}
